export default [
    {
        path: '/about',
        label: 'About Us',
    },
    {
        path: '/stories',
        label: 'Our Stories',
    },
    {
        path: '/events',
        label: 'Events',
    },
    {
        path: '/donate',
        label: 'Donate',
    },
];
